import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { IOption } from '../../../../ui/interfaces/option';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IServiceItemColumnName, ServiceItemColumnName } from '../service-item-column-name';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { AccountRessTypeService } from '../../acc-ress-type/account-ress-type.service';
import { ServiceItemService } from '../service-item.service';
import { FormService } from '../../../../shared/services/form.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { IAccountRessType } from '../../../../model/acc_ress_type.model';
import { BodyType, IServiceItem, ServiceItem } from '../../../../model/service-item.model';
import { Domain } from '../../../../model/domain.model';
import { ServiceItemImageComponent } from '../image/service-item-image.component';
import { SIZE_H_MD_POPUP, SIZE_W_MD_POPUP } from '../../../../shared/constant/css-style/css-size.constant';
import { Formulaire } from '../../../../model/champs_formulaire/formulaire.model';
import { TIME_MIN_REQUEST } from '../../../../shared/constant/request.contant';
import { FormulaireService } from '../../formulaires/formulaire.service';

/**
 * Permet de gérer l'ajout des service items.
 */
@Component({
  selector: 'app-service-item-update',
  templateUrl: './service-item-update.component.html',
  animations: [fadeIn]
})
export class ServiceItemUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  accountRessTypes: IOption[] = [];
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<ServiceItemUpdateComponent>;

  private subs$ = new Subject<void>();
  serviceItem: IOption[] = [];
  editForm: UntypedFormGroup;
  column: IServiceItemColumnName;
  requestType: IOption[] = [];
  bodyFormat: IOption[] = [];

  init = false; // false, si le component n'est pas affiché.

  serviceItemSelected: IServiceItem;
  serviceItemsList: Formulaire[] = [];
  filteredOptions: Observable<Formulaire[]>;

  constructor(
    private formulaireService: FormulaireService,
    private dialog: MatDialog,
    private accountService: AccountService,
    protected accountRessTypeService: AccountRessTypeService,
    private dialogRef: MatDialogRef<ServiceItemUpdateComponent>,
    private serviceItemService: ServiceItemService,
    private formService: FormService,
    private columnName: ServiceItemColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct service item add');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    const bodyFormat = this.columnName.getBodyFormat();
    Object.keys(bodyFormat).forEach((m: string) => {
      this.bodyFormat.push({
        ...new Option(),
        label: bodyFormat[m] ? bodyFormat[m].toLocaleUpperCase() : '',
        value: bodyFormat[m]
      })
    })
    const requestType = this.columnName.getRequestType();
    Object.keys(requestType).forEach((m: string) => {
      this.requestType.push({
        ...new Option(),
        label: requestType[m] ? requestType[m].toLocaleUpperCase() : '',
        value: requestType[m]
      })
    })
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init service item add');
    this.accountService.identity().pipe(takeUntil(this.subs$)).subscribe(res => {
      this.getAllAccRessType();
     // this.getServiceItemList();
    })
    super.setLoaded();
  }

  getInit() {
    return this.init;
  }

  upload() {
    console.log('## open service');
    // this.baseService.open(this.dialog, ServiceItemImageComponent);
    this.dialog.open(ServiceItemImageComponent, {
      height: SIZE_H_MD_POPUP,
      width: SIZE_W_MD_POPUP,
      data: {
        "editForm": this.editForm
      }
    });
  }

  updateTheForm() {
    this.serviceItemService.getServiceItemSelectObs()
      .pipe(takeUntil(this.subs$)).subscribe((res: IServiceItem) => {
      console.log('## get service item selected to liste');
      try {
        console.log('## data: ', res);
        this.serviceItemSelected = res;
        this.editForm.patchValue({
          [this.column.id]: res.id,
          [this.column.name]: res.name,
          [this.column.description]: res.description,
          [this.column.serviceItemId]: res.serviceItemId,
          [this.column.accountRessTypeId]: res.accountRessTypeId.toString(),
          [this.column.accountRessTypeName]: res.accountRessTypeName,
          [this.column.bodyFormat]: res.bodyFormat,
          [this.column.requestType]: res.requestType,
          [this.column.url]: res.url,
          [this.column.type]: res.type,
          [this.column.bodyType]: res.bodyTypeField,
          [this.column.bodyContent]: res.bodyContent,
          [this.column.image]: res.image
        })
        this.init = true;
      }catch (e) {
        console.log('## error get country selected: ' + e.message);
      }
    });
  }

  ngOnDestroy() {
    console.log('## destroy service item add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  displayFnFormulaire(subject: Formulaire) {
    return subject ? subject.titre : '';
  }

  getAllAccRessType() {
    setTimeout(() => {
      this.accountRessTypeService
        .query()
        .pipe(
          filter((mayBeOk: HttpResponse<IAccountRessType[]>) => mayBeOk.ok),
          map((response: HttpResponse<IAccountRessType[]>) => response.body)
        )
        .subscribe((res: IAccountRessType[]) => {
          let acc = (res) ? res : [];
          if(res){
            acc=res;
            this.accountRessTypes=[];
            acc.forEach(a => {
              this.accountRessTypes.push({
                ...new Option(),
                label: (a.type) ? a.type : '',
                value: (a.id) ? a.id.toString() : undefined
              })
            })
          }else{
            acc=[];
            this.accountRessTypes=[];
            this.accountRessTypes.push({
              ...new Option(),
              label: 'No account ressource type',
              value: ''
            })

          }
          // liste form.
          setTimeout(() => {
            this.updateTheForm();
            }, 200)
        },
        (res: HttpErrorResponse) => {
          console.log('## error get acc ress type list: ' +res.message);
        });
    }, 100)
  }

  initForm(fb: UntypedFormBuilder, column: IServiceItemColumnName) {
    try {
      this.editForm = this.fb.group({
        [column.id]: [],
        [column.name]: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(50),
            Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ],
        ['type']: [],
        [column.description]: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(100)]
        ],
        [column.serviceItemId]: ['', [Validators.required, Validators.minLength(1),
          Validators.maxLength(5), Validators.pattern('^[0-9]*$')]],
        [column.accountRessTypeId]: [''],
        [column.accountRessTypeName]: [''],
        [this.column.bodyFormat]: [null],
        [this.column.requestType]: [null, [Validators.required]],
        [this.column.url]: [null, [Validators.required]],
        [this.column.bodyType]: [null],
        [this.column.image]: [null],
        [this.column.bodyContent]: [null],
        'file': []
      });

    }catch (e) {
      console.log('## error form: ' + e.message);
    }
  }

  private _filter(value: string): Formulaire[] {
    let filteredList;
    try {
      const filterValue = value.toLowerCase();
      filteredList = this.serviceItemsList.filter(option => option?.titre?.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter champs formulaire: ' + e.message);
    }
    return filteredList;
  }

  getServiceItemList() {
    setTimeout(() => {
      // SERVICE ITEM
      this.formulaireService
        .query(this.formulaireService.list_url)
        .pipe(
          filter((mayBeOk: HttpResponse<Formulaire[]>) => mayBeOk.ok),
          map((response: HttpResponse<Formulaire[]>) => response.body)
        )
        .subscribe((res: Formulaire[]) => {
            console.log('## success get list formulaire while adding.');
            const rs = res ? res : [];
            console.log('## data: ', rs);
            console.log('## size: ' + rs.length);
            this.serviceItemsList = rs;
            this.filteredOptions = this.editForm.get(this.column.formulaire).valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );
          },
          (res: HttpErrorResponse) => {
            console.log('## error get list formulaire while adding: ' + res.message);
          });
    }, TIME_MIN_REQUEST);
  }

  private createFormData(): any{
    let bodyType: string =  this.editForm.get(['body_type']).value;
    bodyType = bodyType ? bodyType.toString().trim() : bodyType;
    let bodyContent: string = this.editForm.get(['body_content']).value;
    bodyContent = bodyContent ? bodyContent.toString().trim() : bodyContent;
    let url = (this.editForm.get(['url']).value as string);
    url = url ? url.toString().trim() : url;

    const f = new FormData();
    f.set('file', this.editForm.get(['file']).value);
    f.set('id', this.editForm.get(['id']).value);
    f.set('name', this.editForm.get(['name']).value);
    f.set('description', this.editForm.get(['description']).value);
    f.set('serviceItemId', this.editForm.get(['serviceItemId']).value);
    f.set('accountRessTypeId', this.editForm.get(['accountRessTypeId']).value);
    f.set('url', url);
    f.set('type', this.editForm.get(['type']).value);
    f.set('bodyFormat', this.editForm.get(['body_format']).value);
    f.set('image', this.editForm.get(['image']).value);
    f.set('bodyContent', bodyContent);
    f.set('bodyType', bodyType);
    f.set('requestType', this.editForm.get(['request_type']).value);
    return f;
  }

  showKeys(d: any) {
    console.log('## keys');
    d.forEach((k, v) => {
      console.log('## keys| ' + k + ' : ' + v);
    });
  }

  save() {
    console.log('## update service item');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const f = this.createFormData();
    this.showKeys(f);
    this.serviceItemService.updateWithImage(f).subscribe(res => {
        console.log('## success update service item');
        this.serverHasError = false;
        this.responseFromServer();
        this.editForm.reset();
        this.successSave = true;
        this.serviceItemService.getAllServiceItem();
      },
      err => {
        console.log('## error update service item');
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      });
  }

  /**
   * Enregistre un type de account ressource.
   */
/*  save() {
    console.log('## save service item');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const accId = this.editForm.get(['accountRessTypeId']);
    let c: IServiceItem;
    if(accId && accId.value && accId.value.toString() !== '') {
      console.log('## create form with acc ress type');
      c = this.createFromFormWithActRessType();
    } else {
      console.log('## create form without acc ress type');
      c = this.createFromForm();
    }
    console.log('## c: ' + JSON.stringify(c));
    this.serviceItemService.update(c).subscribe(res => {
        console.log('## success create service item');
        this.serverHasError = false;
        this.responseFromServer();
        this.editForm.reset();
        this.successSave = true;
        this.serviceItemService.getAllServiceItem();
      },
      err => {
        console.log('## error create service item');
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      });
  }*/

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): IServiceItem {
    const bodyType: string =  this.editForm.get(['body_type']).value;
    const bodyContent: string = this.editForm.get(['body_content']).value;
    return {
      ...new ServiceItem(),
      id: this.editForm.get(['id']).value,
      name: this.editForm.get(['name']).value,
      description: this.editForm.get(['description']).value,
      serviceItemId: this.editForm.get(['serviceItemId']).value,
      url: (this.editForm.get(['url']).value as string).toString().trim(),
      bodyFormat: this.editForm.get(['body_format']).value,
      image: this.editForm.get(['image']).value,
      bodyContent: bodyContent ? bodyContent.toString().trim() : null,
      bodyType: bodyType
        ? {
          ...new BodyType(),
          field: bodyType.toString().trim()
        }
        : null,
      requestType: this.editForm.get(['request_type']).value
    };
  }

  private createFromFormWithActRessType(): IServiceItem {
    const bodyType: string =  this.editForm.get(['body_type']).value;
    const bodyContent: string = this.editForm.get(['body_content']).value;
    return {
      ...new ServiceItem(),
      id: this.editForm.get(['id']).value,
      name: this.editForm.get(['name']).value,
      description: this.editForm.get(['description']).value,
      serviceItemId: this.editForm.get(['serviceItemId']).value,
      accountRessTypeId: this.editForm.get(['accountRessTypeId']).value,
//      accountRessTypeName: this.editForm.get(['accountRessTypeName']).value,
      url: (this.editForm.get(['url']).value as string).toString().trim(),
      bodyFormat: this.editForm.get(['body_format']).value,
      image: this.editForm.get(['image']).value,
      bodyContent: bodyContent ? bodyContent.toString().trim() : null,
      bodyType: bodyType
        ? {
          ...new BodyType(),
          field: bodyType.toString().trim()
        }
        : null,
      requestType: this.editForm.get(['request_type']).value
    };
  }

  closeModal() {
    console.log('## close country add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }
  reset(){
    this.editForm.reset();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.editForm);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.editForm, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.editForm,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.editForm, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.editForm, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.editForm, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.editForm, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.editForm, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.editForm, column);
  }

}
